import {
  FormType,
  mapNewPermissionsToOldPermissions,
  UserFormPermissions,
  UserGeneralPermissions,
} from "@simplyk/common";

import { UserData } from "../types";

/**
 * Build permission maps from current user's permissions
 * Used to determine which permissions checkboxes should be disabled
 */
export const buildPermissionMaps = (
  currentUser:
    | {
        newPermissions?: {
          generalPermissions?: UserGeneralPermissions[];
          formPermissions?: UserFormPermissions[];
        };
      }
    | null
    | undefined
) => {
  const generalPermissionMap = (currentUser?.newPermissions?.generalPermissions || []).reduce(
    (acc, permission) => {
      acc[permission] = true;
      return acc;
    },
    {} as Record<UserGeneralPermissions, boolean>
  );

  const formPermissionMap = (currentUser?.newPermissions?.formPermissions || []).reduce(
    (acc, permission) => {
      acc[permission] = true;
      return acc;
    },
    {} as Record<UserFormPermissions, boolean>
  );

  return { generalPermissionMap, formPermissionMap };
};

export const buildPermissionsInput = (
  data: UserData,
  selectedCampaigns: {
    label: string;
    value: string;
  }[],
  code?: string | undefined,
  formId?: string,
  formType?: FormType
) => {
  const formPermissionsInput = (Object.keys(data.formPermissions) as UserFormPermissions[]).filter(
    (key) => data.formPermissions[key]
  );
  const generalPermissionsInput = (Object.keys(data.generalPermissions) as UserGeneralPermissions[]).filter(
    (key) => data.generalPermissions[key]
  );
  const permissionFormIdsInput = selectedCampaigns.map((campaign) => campaign.value);
  return {
    permissions: mapNewPermissionsToOldPermissions({
      generalPermissions: generalPermissionsInput,
      formPermissions: formPermissionsInput,
    }),
    formPermissions: formPermissionsInput,
    generalPermissions: generalPermissionsInput,
    permissionFormIds: permissionFormIdsInput.length > 0 ? permissionFormIdsInput : undefined,
    ...(formId && formType
      ? {
          notificationSettings: {
            isEnabled: data.notifications,
            formId,
            formType,
          },
        }
      : {}),
  };
};
